export enum AddmissionTypesEnum {
        InPatient = 2149,
        OutPatient = 2150,
        EmergencyRoom = 2151,
}
